import React, { useEffect, useState } from "react";
import { Container, makeStyles, Box } from "@material-ui/core";
import Page from "src/components/Page";
import Toolbar from "./Toolbar";
import CategoryList from "./CategoryList";
import { useSelector, useDispatch } from "react-redux";
import { fetchAllCategory } from "./_category_Action";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

const Category = () => {
  const classes = useStyles();

  const [filterFn, setParentFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const dispatch = useDispatch();
  let allFetchData = useSelector((state) => state.category._allDetails) || [];

  useEffect(() => {
    dispatch(fetchAllCategory());
    // eslint-disable-next-line
  }, []);

  let viewComponent;
  viewComponent = <CategoryList TableData={allFetchData} filterFn={filterFn} />;

  return (
    <Page className={classes.root} title="Category">
      <Container maxWidth={false}>
        <Toolbar setParentFilterFn={setParentFilterFn} />
        <Box mt={3}>{viewComponent}</Box>
      </Container>
    </Page>
  );
};

export default Category;
